import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import analyticsService from '../services/analyticsService';

export const useInstanceAnalytics = (instanceId: string | undefined, occurrenceId?: string) => {
  return useQuery({
    queryKey: ['analytics', 'instance', instanceId, occurrenceId],
    queryFn: () => analyticsService.getInstanceAnalytics(instanceId!, occurrenceId),
    enabled: !!instanceId,
    staleTime: 60 * 1000,
  });
};

export const useInstanceTrends = (instanceId: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['analytics', 'trends', instanceId],
    queryFn: () => analyticsService.getInstanceTrends(instanceId!),
    enabled: !!instanceId && enabled,
    staleTime: 5 * 60 * 1000,
  });
};

export const useInstanceResponses = (instanceId: string | undefined) => {
  return useQuery({
    queryKey: ['responses', 'instance', instanceId],
    queryFn: () => analyticsService.getInstanceResponses(instanceId!),
    enabled: !!instanceId,
  });
};

export const useRegenerateSummary = (instanceId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => analyticsService.regenerateSummary(instanceId!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['analytics', 'instance', instanceId] });
    },
  });
};

export const useDeleteResponse = (instanceId: string | undefined) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (responseId: string) => analyticsService.deleteResponse(responseId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['responses', 'instance', instanceId] });
      queryClient.invalidateQueries({ queryKey: ['analytics', 'instance', instanceId] });
    },
  });
};
